import { call, put, takeLatest } from 'redux-saga/effects';

import {
  FETCH_CHAPTERS_REQUEST,
  ADD_CHAPTER_REQUEST,
  UPDATE_CHAPTER_REQUEST,
  DELETE_CHAPTER_REQUEST,
} from './actionTypes';

import {
  fetchChaptersRequest,
  fetchChaptersSuccess,
  fetchChaptersFailure,
  addChapterSuccess,
  addChapterFailure,
  updateChapterSuccess,
  updateChapterFailure,
  deleteChapterSuccess,
  deleteChapterFailure,
} from './actions';

import axiosInstance from 'pages/Utility/axiosInstance';
import { showSuccess } from 'helpers/notification_helper';

// ============================
// API Calls
// ============================

const fetchChaptersApi = async (params) => {
  return await axiosInstance.get('V1/chapters', { params });
};

const addChapterApi = async (data) => {
  return await axiosInstance.post('V1/chapters', data);
};

const updateChapterApi = async ({ id, data }) => {
  return await axiosInstance.put(`V1/chapters/${id}`, data);
};

const deleteChapterApi = async (id) => {
  return await axiosInstance.delete(`V1/chapters/${id}`);
};

// ============================
//  Sagas
// ============================

// Fetch Chapters
function* fetchChaptersSaga(action) {
  try {
    const response = yield call(fetchChaptersApi, action.payload);
    yield put(fetchChaptersSuccess(response.data));
  } catch (error) {
    yield put(fetchChaptersFailure(error.message));
  }
}

// Add Chapter
function* addChapterSaga(action) {
  try {
    const response = yield call(addChapterApi, action.payload.data);
    yield put(addChapterSuccess(response.data));
    if (action.payload.callback) action.payload.callback(); 
    yield put(fetchChaptersRequest());
    showSuccess('Chapter added successfully!');
  } catch (error) {
    yield put(addChapterFailure(error?.response?.data?.errors || error.message));
  }
}

// Update Chapter
function* updateChapterSaga(action) {
  try {
    const response = yield call(updateChapterApi, {
      id: action.payload.id,
      data: action.payload.data,
    });
    yield put(updateChapterSuccess(response.data));
    if (action.payload.callback) action.payload.callback(); 
    showSuccess(response?.data?.message || 'Chapter updated successfully!');
  } catch (error) {
    yield put(updateChapterFailure(error?.response?.data?.errors || error.message));
  }
}

// Delete Chapter
function* deleteChapterSaga(action) {
  try {
    const { data } = yield call(deleteChapterApi, action.payload);
    yield put(deleteChapterSuccess(data));
    showSuccess('Chapter deleted successfully!');
  } catch (error) {
    yield put(deleteChapterFailure(error.message));
  }
}

// ============================
//  Watcher
// ============================ 

export default function* chapterSaga() {
  yield takeLatest(FETCH_CHAPTERS_REQUEST, fetchChaptersSaga);
  yield takeLatest(ADD_CHAPTER_REQUEST, addChapterSaga);
  yield takeLatest(UPDATE_CHAPTER_REQUEST, updateChapterSaga);
  yield takeLatest(DELETE_CHAPTER_REQUEST, deleteChapterSaga);
}
